var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"started"},[_c('button',{staticClass:"btn btn-lg btn-success text-uppercase",attrs:{"id":"started"},on:{"click":function($event){return _vm.$emit('startGame')}}},[_vm._v(" "+_vm._s(_vm._f("translate")('Start'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }